module.exports = __webpack_public_path__ + "assets/img/32_623_big.5cd994e6.jpg";